export const REQUEST_STATE = {
		LOADING: "LOADING",
		SUCCESS: "SUCCESS",
		MISSING_DATA: "MISSING_DATA",
		ERROR: "ERROR"
	},
	STATUS_CODE = {
		SUCCESS: 200,
		MISSING_DATA: 404,
		UNAUTHORIZED: 401
	},
	GUEST_COUNT_STRATEGY = {
		SERVICE_TIME: "SERVICE_TIME",
		TOTAL: "TOTAL"
	},
	NOTIFICATION_REDIRECTIONS = {
		SETTINGS_GUEST_COUNT: "/settings/guest-count",
		SETTINGS_SERVICE_TIMES: "/settings/service-times",
		FAQ: "/faq",
		FAQ_PDF_VIDEO: "/faq",
		TRACKED_ITEMS: "/tracked-items",
		MY_GOALS: "/my-goals",
	};
